module.exports = __webpack_public_path__ + "img/sprinkle-28.63dc34a8.webp";